import { ArrowTopRightOnSquareIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import React, { FC } from "react";

export interface SocialsShareProps {
  className?: string;
  itemClass?: string;
}

export interface SocialType {
  id: string;
  name: string;
  icon: string;
  href: string;
}

const socials: SocialType[] = [
  {
    id: "Twitter",
    name: "Twitter",
    icon: `<svg class="w-5 h-5" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.1 43.5C33.21 43.5 43.12 28.49 43.12 15.48c0-.42-.01-.85-.03-1.27C45.02 12.82 46.68 11.1 48 9.11c-1.8.8-3.7 1.3-5.65 1.55 2.05-1.23 3.59-3.17 4.33-5.45-1.93 1.14-4.07 1.98-6.35 2.43-1.48-1.6-3.57-2.6-5.83-2.6-4.41 0-7.99 3.58-7.99 7.99 0 .63.07 1.24.2 1.83-6.64-.33-12.52-3.51-16.47-8.35a7.94 7.94 0 0 0-1.08 4.01c0 2.76 1.41 5.2 3.54 6.63-1.3-.04-2.54-.4-3.62-1v.1c0 3.87 2.76 7.1 6.41 7.84-1.24.34-2.55.39-3.9.15a7.98 7.98 0 0 0 7.45 5.55A16.01 16.01 0 0 1 0 38.1a22.57 22.57 0 0 0 12.23 3.59" fill="currentColor"/>
</svg>`,
    href: "https://x.com/FinVue_?t=vdKQu9vjAiYyqosIkO-PZw&s=08",
  },
  {
    id: "Linkedin",
    name: "LinkedIn",
    icon: `<svg class="w-5 h-5" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M44.45 0H3.54C1.58 0 0 1.55 0 3.46V44.53c0 1.91 1.58 3.46 3.54 3.46H44.45c1.96 0 3.55-1.55 3.55-3.46V3.46C48 1.55 46.41 0 44.45 0ZM14.24 40.9H7.12V18h7.12v22.9ZM10.68 14.87c-2.29 0-4.14-1.85-4.14-4.13S8.39 6.62 10.68 6.62c2.28 0 4.13 1.85 4.13 4.13s-1.85 4.12-4.13 4.12ZM40.9 40.9h-7.12V29.77c0-2.65-.05-6.08-3.69-6.08-3.64 0-4.2 2.9-4.2 5.88V40.9h-7.1V18h7.1v3.13h.1c.95-1.8 3.28-3.7 6.74-3.7 7.21 0 8.54 4.74 8.54 10.91V40.9Z" fill="currentColor"/>
</svg>`,
    href: "https://www.linkedin.com/company/taupe-global-systems/",
  },
  {
    id: "WhatsApp",
    name: "WhatsApp",
    icon: `<svg fill="#fff" class="w-5 h-5" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 308 308" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z"></path> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z"></path> </g> </g></svg>`,
    href: "https://api.whatsapp.com/send?phone=4403300433536",
  },
];

export const SOCIALS_DATA = socials;

const SocialsShare: FC<SocialsShareProps> = ({ className = "grid gap-[6px]", itemClass = "w-7 h-7 text-base hover:bg-neutral-100" }) => {
  const renderItem = (item: SocialType, index: number) => {
    return (
      <a key={index} href={item.href} className={`rounded-full leading-none flex items-center justify-center text-neutral-6000 ${itemClass}`} title={`Share on ${item.name}`}>
        <div dangerouslySetInnerHTML={{ __html: item.icon }}></div>
      </a>
    );
  };

  return (
    <div className={`nc-SocialsShare ${className}`} data-nc-id="SocialsShare">
      {socials.map(renderItem)}
    </div>
  );
};

export default SocialsShare;
